import { DataLoader } from 'src/app/services/data-loader/data-loader';
import { DatasourceColumnId } from 'src/app/utils/datasource-sql-map/datasource';
import { DataLoaderResult } from '../../../services/data-loader/data-loader-result';
import { standardRun } from '../../../services/data-loader/utils/standard-run';
import { GcpProjectId } from 'src/app/utils/gcp-project-id.model';
import { FuncService } from '../../../services/functions-api.service';
import { Factory } from 'src/app/utils/Factory';
import {
    ICreatedInstanceId,
    IQueryCacheService,
    IGcpProjectId,
} from 'src/app/utils/IFactory';
import { IDatasourceColumnId } from 'src/app/utils/dashboard-item';
import { QueryCacheService } from 'src/app/services/query-cache.service';

export class SegmentDatasourceColumnDataLoaderFactoryOptions
    implements ICreatedInstanceId, IQueryCacheService, IDatasourceColumnId
{
    constructor(
        public createdInstanceId: string,
        public gcpProjectId: GcpProjectId | (() => GcpProjectId),
        public queryCacheService: QueryCacheService,
        public datasourceColumnId: DatasourceColumnId = 'SEGMENT',
    ) {}
}

export class SegmentDataSourceColumnDataLoaderFactory extends Factory<
    DataLoader,
    SegmentDatasourceColumnDataLoaderFactoryOptions
> {
    override FACTORY_CLASS: string = 'SegmentDataSourceColumnDataLoaderFactory';

    override getInstance(
        options: SegmentDatasourceColumnDataLoaderFactoryOptions,
    ): DataLoader {
        return new DataLoader(options.createdInstanceId, async function (
            queryContext,
            cancellationToken,
        ) {
            const datasourceColumnID: DatasourceColumnId =
                options.datasourceColumnId;
            // const datasourceSqlMap: IDatasourceSQLMap =

            // Resolve gcpProjectId to always be a value
            const resolvedGcpProjectId: GcpProjectId =
                typeof options.gcpProjectId === 'function'
                    ? options.gcpProjectId()
                    : options.gcpProjectId;

            const process = async () => {
                const query = `SELECT DISTINCT segment AS ${datasourceColumnID} FROM \`${resolvedGcpProjectId}.bi_core.segments\` ORDER BY 1`;
                this.emitter.emit(
                    DataLoaderResult.getLoading(this.latestData, queryContext),
                );

                const queryResponse = await DataLoader.runQuery(
                    query,
                    options.queryCacheService,
                );
                const data = [...queryResponse.result];

                cancellationToken.throwIfCancellationRequested();

                this.emitter.emit({
                    data,
                    queryContext,
                    status: 'ok',
                    statusMessage: '',
                    isLoading: false,
                    sqlAndJsProcessing: query,
                });
            };

            await standardRun(this, queryContext, process);
        });
    }
}
